import React from 'react'
import $ from 'jquery';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { validaPerfis } from '../../security/Autorizacao';
import { getVendedorAgencia } from '../../security/securityContext';
import { EMPRESA_POLITUR } from '../../util/constantsUtil';

export class MapaVeiculoItinerario extends React.Component {
  constructor (props) {
    $(document)
      .ready(function () {
        $('[data-toggle="tooltip"]')
          .tooltip();
      });
    super(props);
    this.state = {
      andarSelecionado: 1
    }
  }

  // eslint-disable-next-line class-methods-use-this
  exibirCorredor (fileira) {
    return (fileira.exibeCorredor ? <div className="transport-meio-corredor" key={`corredor-${fileira.id}`}/> : '')
  }

  // eslint-disable-next-line class-methods-use-this
  exibirFileira (fileira) {
    if (fileira.assentos.length > 0) {
      return (
        <div className="transport-meio-fileira" key={`fileira-${fileira.numero}-${this.props.andar}`}>
          {this.exibirAssentos(fileira)}
          <label htmlFor="_" className="transport-meio-assento espaco-vago" key='meio6'>_</label>
        </div>
      )
    }
  }

  exibirAssentos (fileira) {
    return fileira.assentos.map(assento => <div key={`assento-${this.props.sentido}-${fileira.numero}-${assento.ordem}`}>
      {this.props.bloqueio ? this.exibirAssentoBloqueio(assento, fileira) : this.exibirAssento(assento, fileira)}
    </div>)
  }

  selecionarEMarcarPoltrona (assento, fileira) {
    this.props.selecionar(assento, fileira, this.props.sentido)
  }

  recuperarDadosBloqueio (poltrona) {
    const trechos = poltrona.bloqueios.map(bloqueio => `<li>${bloqueio.trechoOrigem} -> ${bloqueio.trechoDestino}</li>`);
    const tabela = '<div><span>Poltrona bloqueada nos trechos:</span>' +
      '      <ul>' +
      trechos
    '    </ul></div>';
    return tabela;
  }

  recuperarDadosReserva (poltrona) {
    if(this.props.empresaSelecionada.habilitadoBuscaReservaComBpe){
      return '';
    }
    const dados = poltrona.reservas.map(reserva => `<strong>Vendedor:</strong> ${reserva.nomeVendedor}<br/>
    <strong>Passageiro:</strong> ${reserva.passageiroDto.nome}<br/>
    <strong>Trecho:</strong> ${reserva.descCidadeOrigem} -> ${reserva.descCidadeDestino}
    <br/><br/>
    `
    );
    const tabela = '<div><span>Vendida</span></div><br/>' +
      '<div>' +
      dados +
      '</div>';
    return tabela.replace(',', '');
  }

  recuperarMensagemAproveitamento (poltrona) {
    if (poltrona && !poltrona.reservada && poltrona.reservas && poltrona.reservas.length) {
      return '<div><strong>Atenção!</strong></div></br>' +
        '<strong>Venda esta proltrona para melhor aproveitamento no carro!</strong>'
    }
    return '<div><strong>Atenção!</strong></div></br>' +
      '<strong>Dê prioridade a venda das poltronas azuis!</strong>'

  }

  exibirAssento (assento, fileira) {
    const { poltrona } = assento;
    if (assento.tipoAssento !== 'NORMAL') {
      return <label key={assento.id} className="espaco-vago  js-seat-selected-amplitude"></label>
    }

    if (!poltrona || poltrona.bloqueoPorTipoCategoria) {
      return <label data-toggle="tooltip" data-html="true" title="" key={assento.id} className="assento assento-ocupado"></label>
    }

    if (!poltrona || poltrona.bloqueada) {
      return <label data-toggle="tooltip" data-html="true" title={this.recuperarDadosBloqueio(poltrona)} key={assento.id} className="assento assento-ocupado" style={{
        backgroundColor: 'red',
        color: '#FFF'
      }}>{poltrona.numero}</label>
    }

    if (!poltrona || poltrona.reservada) {
      return <label data-toggle="tooltip" data-html="true" title={this.recuperarDadosReserva(poltrona)} key={assento.id} className="assento assento-ocupado">{poltrona.numero}</label>
    }

    // if (!poltrona.reservada && poltrona.reservas && poltrona.reservas.length) {
    //   return <label style={{
    //     backgroundColor: '#2b4ec6',
    //     color: '#FFF' }} data-toggle="tooltip" data-html="true"
    //                 title={this.recuperarMensagemAproveitamento()} key={assento.id} className="assento assento-ocupado">{poltrona.numero}</label>
    // }

    return (
      <label key={assento.id} style={!assento.selecionado ? !poltrona.reservada && poltrona.reservas && poltrona.reservas.length ? {
        backgroundColor: '#2b4ec6',
        color: '#FFF'
      } : {
        backgroundColor: '#02c659',
        color: '#FFF'
      } : null}
             className={`assento assento-disponivel  js-seat-selected-amplitude ${assento.selecionado ? assento.ehBloqueado ? 'assento-bloqueado' : 'assento-selecionado' : ''}`}>
        {poltrona.numero}
        <input data-toggle="tooltip" data-html="true"
               title={this.recuperarMensagemAproveitamento(poltrona)} type="checkbox" name={poltrona.id} id={poltrona.id} data-assento={poltrona.numero}
               onClick={() => {
                 this.selecionarEMarcarPoltrona(assento, fileira);
                 if (document.querySelectorAll('[role="tooltip"]')[0]) {
                   document.querySelectorAll('[role="tooltip"]')[0].remove();
                 }
               }}
               value={poltrona.numero}/>

      </label>
    )
  }


  exibirAssentoBloqueio (assento, fileira) {
    const { poltrona } = assento;
    if (assento.tipoAssento !== 'NORMAL') {
      return <label key={assento.id} className="espaco-vago  js-seat-selected-amplitude"></label>
    }
    return (
      <label key={assento.id}
             className={'assento assento-disponivel  js-seat-selected-amplitude'}
             style={{
               backgroundColor: assento.selecionado ? 'green' : poltrona.bloqueada ? 'red' : '',
               color: poltrona.bloqueada || assento.selecionado ? 'white' : ''
             }}>
        {poltrona.numero}
        <input type="checkbox" name={poltrona.id} id={poltrona.id} data-assento={poltrona.numero}
               onClick={() => this.selecionarEMarcarPoltrona(assento, fileira)}
               value={poltrona.numero}/>

      </label>
    )
  }

  exibirMapaVeiculo () {
    if (this.props.mapaVeiculo && this.props.mapaVeiculo.length) {
      return (this.props.mapaVeiculo.map(fileira => <React.Fragment key={fileira.id}>
        <div>
          {this.exibirFileira(fileira)}
        </div>
        {this.exibirCorredor(fileira)}
      </React.Fragment>))
    }
  }

  naoEhPerfilVendedor() {
    return !validaPerfis([getVendedorAgencia(this.props.empresaSelecionada.id)])
  }

  render () {
    return (
      <React.Fragment>
        {this.props.exibeBotoesRedirecionamento ?
          <React.Fragment>
            {this.props.empresaSelecionada.id === EMPRESA_POLITUR ? <>
              {this.naoEhPerfilVendedor() && <Link target="_BLANK" className="btn btn-laranja ml-1 vertical-center"
                  title='Lista de passageiros'
                  to={`/painel-lista-passageiros?itinerario=${this.props.idItinerario}&empresa=${this.props.empresaSelecionada.id}`}>
                Lista de passageiros
              </Link>}</>
              :<><Link target="_BLANK" className="btn btn-laranja ml-1 vertical-center"
                  title='Lista de passageiros'
                  to={`/painel-lista-passageiros?itinerario=${this.props.idItinerario}&empresa=${this.props.empresaSelecionada.id}`}>
              Lista de passageiros
            </Link></>}

            <Link target="_BLANK" className="btn btn-laranja ml-1 justify-content-end"
                  title='Mapa de viagem'
                  to={`/mapa-viagem-itinerario?itinerario=${this.props.idItinerario}&empresa=${this.props.empresaSelecionada.id}`}>
              Mapa de viagem
            </Link>
          </React.Fragment> : ''}

        <div className="col-12 titulo-principal-componente">
          <h1 id="titulo-page" className="text-center">{this.props.trecho}</h1>
          <h4 id="titulo-page" className="text-center">Saída {this.props.data} - Chegada {this.props.dataChegada}</h4>
          {this.props.nomePrestador? <h1 id="titulo-page" className="text-center">Prestador: {this.props.nomePrestador} </h1> : ''}
          <h4 id="titulo-page" className="text-center"><p className="linha"></p></h4>
        </div>
        <div className="transport-result-wrapper transport-result-wrapper-connection " data-wrapper-direction="">
          <div className="js-count-transport">
            <div className="transport bus-design bus-design-side ">
              <div className="transport-frente"/>
              <div className="transport-meio transport-meio-thin">
                {this.exibirMapaVeiculo()}
              </div>
              <div className="transport-traseira"/>
            </div>
          </div>
        </div>
      </React.Fragment>
    )
  }
}


export function mapStateToProps (state) {
  return {
    empresaSelecionada: state.empresaSelecionada
  }
}


export default connect(mapStateToProps, {})(MapaVeiculoItinerario)
